
import React from 'react';
import { useMasterLicense } from '@/hooks/useMasterLicense';
import MasterLicenseSettingsLayout from '@/components/masterlicense/settings/MasterLicenseSettingsLayout';
import { MasterLicenseSettingsProvider } from '@/contexts/MasterLicenseSettingsContext';
import MasterLicenseSettingsTabContainer from '@/components/masterlicense/settings/MasterLicenseSettingsTabContainer';
import { useToast } from '@/hooks/use-toast';

const MasterLicenseSettings = () => {
  const { isLoading, handleLogout, user } = useMasterLicense();
  const { toast } = useToast();

  const handleSaveSettings = (section: string) => {
    toast({
      title: "Settings Saved",
      description: `${section} settings have been updated successfully.`,
    });
  };

  return (
    <MasterLicenseSettingsProvider isLoading={isLoading}>
      <MasterLicenseSettingsLayout
        isLoading={isLoading}
        handleLogout={handleLogout}
        userRole={user?.role || 'Master Admin'}
        activeTab="settings"
      >
        <div className="max-w-7xl mx-auto">
          <h1 className="text-2xl font-bold mb-6">License Portal Settings</h1>
          <div className="bg-white rounded-lg shadow-sm border">
            <MasterLicenseSettingsTabContainer 
              isLoading={isLoading} 
              onSaveSettings={handleSaveSettings}
            />
          </div>
        </div>
      </MasterLicenseSettingsLayout>
    </MasterLicenseSettingsProvider>
  );
};

export default MasterLicenseSettings;
